(function () {
  class SideMenu extends PIXI.Container {
    constructor(screenMaskId, closeButtonId) {
      super();

      this._screenMaskId = screenMaskId;
      this._closeButtonId = closeButtonId;

      this._settingsOpen = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe("game:sideMenuOpen", this.onSideMenuOpen.bind(this));
      messageBus.subscribe(
        "game:sideMenuClosed",
        this.onSideMenuClosed.bind(this)
      );
      messageBus.subscribe("ui:modal", this.onUIModal.bind(this));
      messageBus.subscribe("game:modal", this.onModal.bind(this));

      this.visible = false;
    }

    initialise() {
      this._dimScreen = resourceManager.get(this._screenMaskId);
      this._closeButton = resourceManager.get(this._closeButtonId);

      this._background = resourceManager.get("overSlotContainerMaskDimObject");
      this._background.interactive = true;

      resourceManager.get("sideMenu:sideMenuPanel:bg:history").visible =
        this._activeButtons.btnHistory.visible;
      resourceManager.get("sideMenu:sideMenuPanel:bg:options").visible =
        this._activeButtons.btnInfo.visible;
      resourceManager.get("sideMenu:sideMenuPanel:bg:settingsMenu").visible =
        this._activeButtons.btnSettings.visible;
      resourceManager.get("sideMenu:sideMenuPanel:bg:gameRules").visible =
        this._activeButtons.btnRules.visible;

      this._closeButton.mousedown = this._closeButton.touchstart = function () {
        messageBus.postImmediate("game:sideMenuClosed", {});
        messageBus.postImmediate("game:settingMenuClosed", {});
      };

      this._background.mousedown = this._background.touchstart = function () {
        messageBus.postImmediate("game:sideMenuClosed", {});
        messageBus.postImmediate("game:settingMenuClosed", {});
      };
    }

    onGameConfigEvent(config) {
      this._activeButtons = config.data.uiElements;

      /*this._activeButtons.btnInfo.visible = false;
            this._activeButtons.btnSettings.visible = false;
            this._activeButtons.btnFullscreen.visible = false;
            this._activeButtons.btnRules.visible = false;*/

      //this._activeButtons.btnHistory.visible = true;

      resourceManager.get(
        "sideMenu:sideMenuPanel:bg:history:highlight"
      ).visible = false;

      this.initialise();
    }

    onSideMenuOpen() {
      if (this._dimScreen !== undefined) {
        this._dimScreen.show(true, 1);
      }
      this._closeButton.interactive = true;
      this.visible = true;
      messageBus.post("game:modal", { reason: "Side Menu Open" });
    }

    onSideMenuClosed() {
      if (this._dimScreen !== undefined) {
        this._dimScreen.show(false);
      }
      this._closeButton.interactive = false;
      this.visible = false;
      messageBus.post("game:modal", {});
    }

    onUIModal(event) {
      switch (event.reason) {
        case "History open": {
          resourceManager.get(
            "sideMenu:sideMenuPanel:bg:history:highlight"
          ).visible = true;
          this._settingsOpen = true;
          break;
        }
      }
    }

    onModal(event) {
      if (event.reason === undefined || event.reason === "") {
        // activating golden bet forces us out of modal on the stake change - catch this here
        // if the settings dialog is open - not post is used here to ensure this is actioned in the correct order
        if (resourceManager.get("settingsMenu").visible) {
          messageBus.post("game:modal", { reason: "Settings menu open" });
        } else if (this._settingsOpen) {
          this._settingsOpen = false;
          resourceManager.get(
            "sideMenu:sideMenuPanel:bg:history:highlight"
          ).visible = false;
          messageBus.postImmediate("game:sideMenuClosed", {});
        }
      }
    }
  }

  var sideMenuCreator = function (json) {
    return new SideMenu(json.screenMaskId, json.closeButtonId);
  };

  var sideMenuInitialiser = function (json) {};

  var sideMenuFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "sideMenu",
    sideMenuCreator,
    sideMenuInitialiser,
    sideMenuFilesRequired
  );
})();
